import { styled } from "styled-components";

export const PaymentWrapper = styled.div`
  padding-top: 24px;
  display: grid;
  gap: 16px;
`;
